import Tooltip from "../../theme/Tooltip";
import {
  FiMinus as LuMinus,
  FiPlus as LuPlus,
  FiShoppingCart,
  FiX,
} from "react-icons/fi";
import {
  Box,
  Button,
  VStack,
  HStack,
  Image,
  Text,
  NumberInput,
  IconButton,
  Separator,
} from "@chakra-ui/react";
import ButtonC from "../../theme/ButtonC";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
export default function CartDrawer({
  isOpen,
  onClose,
  cartItems,
  onUpdateItem,
  onCheckout,
  onRemoveItem,
}) {
  const border = "gray.200";
  const navigate = useNavigate();
  const itemsToRender = cartItems;
  const [loading, setLoading] = useState(true);
  const {
   
    final_total,
    total,
    discount,
    shipping_fee,
    offer_discount,
    status: cartStatus
  } = useSelector((state) => state.cart);

  const productTotals = {};
  cartItems.forEach((item) => {
    if (!productTotals[item.product_id]) {
      productTotals[item.product_id] = 0;
    }
    productTotals[item.product_id] += item.quantity;
  });

  const hasMOQFailure = cartItems.some(item => {
  const totalQty = productTotals[item.product_id];
  return totalQty < item.min_order_quantity;
});

  return (
    <Box
      w={{ base: "100%", sm: "450px" }}
      color="var(--crt-2)"
      display="flex"
      flexDirection="column"
      h="100%"
      bg="white"
    >

      <HStack
        justify="space-between"
        p={4}
        borderBottomWidth="1px"
        borderColor={border}
      >
        <HStack alignItems="center" justifyContent="flex-start">
          <FiShoppingCart size={20} color="var(--cr-blue-1)" />
          <Text fontSize="sm" fontWeight="semibold" pt={4}>
            Your Cart
          </Text>
        </HStack>
        <Button size="sm" variant="ghost" onClick={onClose}>
          ✕
        </Button>
      </HStack>


      <VStack align="stretch" p={4} flex="1" overflowY="auto" spacing={5}>
        {!loading && (!itemsToRender || itemsToRender.length === 0) && (
          <Text color="gray.500" textAlign="center">
            Your cart is empty
          </Text>
        )}

        {itemsToRender &&
          itemsToRender
            .filter((item) => item.variant && item.product)
            .map((item) => {
              const totalQty = productTotals[item.product_id];
              const isMOQFailed = totalQty < item.min_order_quantity;

              return (
                <Box key={item.id}>
                  <HStack align="flex-start" justify="flex-start">
                    <Image
                      src={item.variant?.thumb_images?.[0]?.url}
                      alt={item.product?.name}
                      boxSize={{ base: "100px", sm: "120px" }}
                      objectFit="contain"
                      borderRadius="md"
                      flexShrink={0}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/product/${item.product?.slug}`)}
                    />

                    <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          gap: 4,
                        }}
                      >
                        <Text fontWeight="semibold" fontSize="sm" noOfLines={2}>
                          {item.product?.name}
                        </Text>

                        <Tooltip content="Remove">
                          <IconButton
                            aria-label="Remove"
                            borderColor="gray.300"
                            borderRadius="sm"
                            color="gray.600"
                            variant="outline"
                            size="2xs"
                            flexShrink={0}
                            onClick={() => {
                              setLoading(true);
                              onRemoveItem({
                                product_id: item.product.id,
                                variant_id: item.variant.id,
                              });
                              setTimeout(() => setLoading(false), 500);
                            }}
                          >
                            <FiX />
                          </IconButton>
                        </Tooltip>
                      </div>

          
                      <div style={{ fontSize: "12px", color: "gray" }}>
                        {item.variant?.size?.name && (
                          <Text>
                            Size:{" "}
                            <Text as="span" fontWeight="medium" fontSize="sm">
                              {item.variant.size.name}
                            </Text>
                          </Text>
                        )}
                      </div>

             
                      <HStack justify="space-between" w="full" pt={1}>
                        <NumberInput.Root size="xs" value={item.quantity} min={1} max={100}>
                          <HStack gapX="2">
                            <NumberInput.DecrementTrigger asChild>
                              <IconButton
                                color="var(--cr-red-logo)"
                                borderColor="var(--cr-red-logo)"
                                borderRadius="sm"
                                variant="outline"
                                size="2xs"
                                onClick={() => {
                                  setLoading(true);
                                  onUpdateItem({
                                    product_id: item.product.id,
                                    variant_id: item.variant.id,
                                    quantity: item.quantity - 1,
                                  });
                                  setTimeout(() => setLoading(false), 500);
                                }}
                              >
                                <LuMinus />
                              </IconButton>
                            </NumberInput.DecrementTrigger>

                            <NumberInput.ValueText textAlign="center" fontSize="sm" minW="3ch" />

                            <NumberInput.IncrementTrigger asChild>
                              <IconButton
                                color="var(--cr-green-1)"
                                borderColor="var(--cr-green-1)"
                                borderRadius="sm"
                                variant="outline"
                                size="2xs"
                                onClick={() => {
                                  setLoading(true);
                                  onUpdateItem({
                                    product_id: item.product.id,
                                    variant_id: item.variant.id,
                                    quantity: item.quantity + 1,
                                  });
                                  setTimeout(() => setLoading(false), 500);
                                }}
                              >
                                <LuPlus />
                              </IconButton>
                            </NumberInput.IncrementTrigger>
                          </HStack>
                        </NumberInput.Root>

                        <Text fontWeight="semibold" fontSize="sm" whiteSpace="nowrap">
                          ₹{(item.variant.display_price * item.quantity).toFixed(2)}
                        </Text>
                      </HStack>

                     
                    </div>
                  </HStack>
                   {isMOQFailed && (
                        <Text fontSize="12px" color="red" fontStyle="italic" mt={1}>
                          Minimum {item.min_order_quantity} pieces required for this product.  
                          You have added only {totalQty}.
                        </Text>
                      )}
                  <Separator mt={4} />
                </Box>
              );
            })}
      </VStack>

      
      {cartItems && cartItems.length > 0 && (
        <Box p={4} borderTopWidth="1px" borderColor={border}>
          <HStack justify="space-between" mb={1}>
            <Text fontWeight="medium" fontSize="sm" >Subtotal</Text>
            <Text fontWeight="bold" fontSize="sm">
              ₹
              {cartItems.reduce((sum, item) => sum + (item.variant.orignial_price || item.variant.display_price) * item.quantity, 0).toFixed(2)}
            </Text>
          </HStack>
          <HStack justify="space-between" mb={1}>
            <Text fontWeight="medium" fontSize="sm">Discount</Text>
            <Text fontWeight="bold" fontSize="sm">
              - ₹
              {(cartItems.reduce((sum, item) => sum + ((item.variant.orignial_price || item.variant.display_price) * item.quantity) , 0)- total).toFixed(2)}
            </Text>
          </HStack>
          {offer_discount && offer_discount > 0  ? <HStack justify="space-between" mb={1} pt={2} borderTopWidth="1px">
            <Text fontWeight="medium" fontSize="sm">Offer Discount</Text>
            <Text fontWeight="bold" fontSize="sm">
              - ₹
              {offer_discount.toFixed(2)}
            </Text>
          </HStack> : null}
          <HStack justify="space-between" mb={1}>
            <Text fontWeight="medium" fontSize="sm">Shipping</Text>
            <Text fontWeight="bold" fontSize="sm">
              ₹
              {shipping_fee.toFixed(2)}
            </Text>
          </HStack>
          <HStack justify="space-between" mb={3} pt={2} borderTopWidth="1px">
            <Text fontWeight="medium" fontSize="sm">Total</Text>
            <Text fontWeight="bold" fontSize="sm">
              ₹
              {final_total.toFixed(2)}
        
            </Text>
          </HStack>

          <ButtonC
            label="Proceed to Checkout"
            type="submit"
            w="full"
            borderRadius="md"
            disabled={hasMOQFailure}
            onClick={onCheckout}
          />
        </Box>
      )}
    </Box>
  );
}
